import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力} from '@/type/validation/validator';
import {定数在庫表出力依頼型} from '@/type/custom/goryoukaku/定数在庫表出力依頼型';


export default class 定数在庫表出力依頼チェッカー {
  単項目チェック結果: Error[];

  constructor(target: 定数在庫表出力依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果
      .map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '在庫場所',
    constraints: [
      {method: 必須入力, message: '在庫場所は入力必須項目です'},
    ],
  },
  {
    name: 'チェック回数',
    constraints: [
      {method: 必須入力, message: 'チェック回数は入力必須項目です'},
    ],
  },
];

